import React from 'react';
import { DashboardLayout } from '../components/DashboardLayout';
import { RiskDashboard } from '../components/RiskDashboard';
import { motion } from 'framer-motion';

export const RiskAssessmentPage: React.FC = () => {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Risk Assessment</h1>
            <p className="text-sm sm:text-base text-gray-600 mt-1">Analyze and manage risks across your leads</p>
          </div>
        </div>

        {/* Risk Dashboard */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <RiskDashboard />
        </motion.div>
      </div>
    </DashboardLayout>
  );
}; 